import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=a5e84e2a"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"
import style0 from "./home-page.vue?vue&type=style&index=0&id=a5e84e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports